function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS, logicalCSSWithFallback, euiScrollBarStyles, euiFontSize } from '../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1dbd2rc-euiPagination__list",
  styles: "display:flex;align-items:baseline;label:euiPagination__list;"
} : {
  name: "1dbd2rc-euiPagination__list",
  styles: "display:flex;align-items:baseline;label:euiPagination__list;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiPaginationStyles = function euiPaginationStyles(euiThemeContext) {
  var euiTheme = euiThemeContext.euiTheme;
  return {
    // Base
    euiPagination: /*#__PURE__*/css(euiScrollBarStyles(euiThemeContext), " display:flex;align-items:center;", logicalCSSWithFallback('overflow-y', 'hidden'), " ", logicalCSSWithFallback('overflow-x', 'auto'), ";;label:euiPagination;"),
    // Elements
    euiPagination__compressedText: /*#__PURE__*/css("display:inline-flex;align-items:center;line-height:1;>span{", logicalCSS('margin-horizontal', euiTheme.size.s), " font-weight:", euiTheme.font.weight.semiBold, ";&:first-of-type{color:", euiTheme.colors.primaryText, ";}};label:euiPagination__compressedText;"),
    euiPagination__list: _ref,
    euiPagination__ellipsis: /*#__PURE__*/css("color:", euiTheme.colors.disabledText, ";font-size:", euiFontSize(euiThemeContext, 's').fontSize, ";", logicalCSS('padding-horizontal', euiTheme.size.s), " ", logicalCSS('height', euiTheme.size.l), ";;label:euiPagination__ellipsis;")
  };
};